import React from 'react';
import { useTheme } from 'styled-components';
import Form from '../../../../../form';
import { TFormVariant } from '../../../../../form/Form.types';
import { useSkeletonContext } from '../../input-skeleton.context';
import { InputActionContent, InputActionSC } from './input-action.styled';

type TExtend = Omit<
  React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
  'children'
>;

interface InputActionProps extends TExtend {
  Icon: (props: React.SVGProps<SVGSVGElement>) => JSX.Element;
  variant?: TFormVariant;
  focused?: boolean;
  disabled?: boolean;
}

const InputAction = (
  { Icon, variant, focused, onClick, ...rest }: InputActionProps,
  ref?: React.Ref<HTMLButtonElement>,
) => {
  const theme = useTheme();
  const settings = Form.useFormSettings({ variant });
  const { disabled, readonly } = useSkeletonContext();
  const finalDisabled = disabled || readonly || rest.disabled;

  return (
    <InputActionSC
      {...rest}
      ref={ref}
      disabled={finalDisabled}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick?.(e);
      }}
    >
      <InputActionContent>
        <Icon
          width={24}
          height={24}
          color={
            settings.variant === 'on-dark' ? theme.color.tint.actionDark : theme.color.tint.action
          }
        />
      </InputActionContent>
    </InputActionSC>
  );
};

export default React.forwardRef(InputAction);
